import React from "react"
import styled, { css } from "styled-components"
import Img from "gatsby-image"
import Breakpoints from "./breakpoints"
import { T } from "./typography.styles"
import { Link } from "react-scroll"
import FadedTitle from "../shared/faded-title"

export const ContactFormLink = styled(Link)`
  ${T.lg.h3.bold}
  grid-column: 1 / -1;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 11px;
  min-height: 46px;
  justify-self: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2em;
  min-width: 282px;
  width: 282px;
  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 48px;
  display: inline-block;
  border: none;
  outline: none;
`

export const Divider = styled.div`
  grid-column: 1 / -1;
  height: ${props => props.sm ?? "64px"};

  @media (min-width: ${Breakpoints.md}) {
    height: ${props => props.md ?? "64px"};
  }
  @media (min-width: ${Breakpoints.lg}) {
    height: ${props => (props.lg ? props.lg : props.large ? "128px" : "96px")};
  }
`

export const SectionTitle = styled.h2`
  ${T.sm.h2.bold}
  color: var(--slate);
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2.bold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2.bold}
  }
`

export const FeatureTitle = styled.h3`
  color: var(--slate);
  ${T.md.h3.bold}
  grid-column: 1 / -1;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3.bold}
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3.bold}
    text-align: left;
    margin-top: 0px;
  }

  ${props => props.styleModifier}
`

export const FeatureTextContainer = styled.div`
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
`

export const FeatureText = styled.p`
  ${T.sm.body.regular}
  color: var(--body-text-grey);
  grid-column: 1 / -1;
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
    grid-column: 2 / -2;
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
    text-align: left;
  }
  ${props => props.styleModifier}
`

export const FeatureContent = styled.div`
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    align-self: center;
    grid-row: ${props => props.gridRow};
  }
  ${props => props.styleModifier}
`

export const BaseImage = styled(Img)`
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }

  @media (min-width: ${Breakpoints.lg}) {
    align-self: center;
  }
  ${props => props.styleModifier}
`

export const BaseSVGImage = styled.img`
  grid-column: 1 / -1;
  object-fit: contain;
  max-width: 100%;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }

  @media (min-width: ${Breakpoints.lg}) {
    align-self: center;
  }
  ${props => props.styleModifier}
`
export const LeftContentStyle = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
  }
`

export const RightContentStyle = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -6 / -2;
  }
`

export const LeftImageStyle = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    grid-row: 4;
  }
`

export const RightImageStyle = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -2 / -7;
  }
`

export const FeatureGridContainer = styled.div`
  background-color: var(--tricorn-black);
  padding: 64px 0;

  @media (min-width: ${Breakpoints.md}) {
    padding: 48px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 128px 0 64px 0;
  }
`

export const FeatureGridTitleContainer = styled.div`
  grid-column: 1 / -1;

  & h3 {
    color: var(--dark-mode-body-grey);
  }
  margin-bottom: 48px;
  justify-self: center;

  @media (min-width: ${Breakpoints.md}) {
    margin-bottom: 64px;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
    & h3 {
      font-size: 36px;
    }
    margin-bottom: 96px;
  }
`

export const DividingLine = styled.div`
  width: calc(100vw - 40px);
  margin: 0 20px;
  border-bottom: 1px solid #2e2e2e33;

  @media (min-width: ${Breakpoints.md}) {
    width: 77.6vw;
    margin: 0 auto 0 auto;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin: 0 auto 0 auto;
  }
`

export const VerticalsFadedTitle = props => {
  return (
    <FadedTitle
      sm={T.sm.h2.bold}
      md={T.md.h2.bold}
      lg={T.lg.h2.bold}
      {...props}
    />
  )
}

export const Italics = styled.span`
  font-style: italic;
`
